/**
 * True on Apple hardware, where the save shortcut is written ⌘S rather than Ctrl+S. Both modifiers
 * are handled at runtime regardless — this only decides which spelling a keyboard hint shows.
 */
export const isApplePlatform = (): boolean => /mac|iphone|ipad|ipod/i.test(navigator.userAgent);
